export type Address = {
  line1: string;
  line2?: string | null;
  postalCode: string;
  city: string;
};

export const formatAddressInOneLine = ({
  line1,
  line2,
  postalCode,
  city,
}: Address) => {
  return [line1, line2, `${postalCode} ${city}`]
    .filter((onePart) => onePart !== undefined && onePart !== null)
    .filter((onePart) => onePart?.trim() !== "")
    .join(", ");
};

export const formatStreetAddressInOneLine = ({
  line1,
  line2,
}: Omit<Address, "postalCode" | "city">) => {
  return [line1, line2]
    .filter((onePart) => onePart !== undefined && onePart !== null)
    .filter((onePart) => onePart?.trim() !== "")
    .join(", ");
};
